import { IJob, IUser, ProfessionTypeEnum } from '~/models';
import { UserProfession } from '~/enums/UserProfession';
import { Colors } from '~/themes/colors';

interface IDnDaProceduresProps {
  candidate: IUser;
  job: IJob | null;
}

export const DnDaProcedures = ({ candidate, job }: IDnDaProceduresProps) => {
  const candidateEducation = candidate?.professional_info?.education;
  const candidateProfession = candidate?.license?.profession;
  const profession = (job?.profession || candidateProfession) as ProfessionTypeEnum;

  return (
    [UserProfession.DN, UserProfession.DA].includes(profession) && (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          marginTop: 12,
        }}
      >
        {Object.keys(candidateEducation?.[profession]?.specialtiesAndProcedures || {})?.map(
          (name) => (
            <div key={name}>
              <b
                id={name}
                style={{
                  fontSize: 18,
                  color: Colors.primary_500,
                }}
              >
                {name?.split('_')?.[1]}
              </b>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 4,
                  marginTop: 8,
                }}
              >
                {candidateEducation?.[profession]?.specialtiesAndProcedures?.[name]?.map((item) => (
                  <span key={item} style={{ color: Colors.neutral_600 }}>
                    {`\u2022  ${item?.split('_')?.[1]}`}
                  </span>
                ))}
              </div>
            </div>
          ),
        )}
      </div>
    )
  );
};
